import styled from '@emotion/styled';
import { SubLabel } from '@components/atoms/Label';
import { CrossIcon } from '@components/atoms/Icons/Cross';
import { icons } from '@assets/icons';

export const PacsSettingsFieldWrapper = styled.fieldset<{ type: string }>`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
  border-left: 6px solid #999;
  margin: 0 0 10px 0;
  padding: 0;
  display: grid;
  grid-template-rows: ${({ type }) => `${type === 'CLOUD' ? '360px' : '250px'}`};
  grid-row-gap: 10px;
  grid-template-columns: 1fr 180px;
  grid-column-gap: 20px;
  grid-template-areas: 'scp ssl';
  background: unset;

  &.active {
    border-left: 6px solid #00bf00;

    & th {
      background-color: #00bf00;
      border-left: 4px solid #7fe200;
    }
  }
`;

export const ScpAeInfoSection = styled.section`
  position: relative;
  grid-area: scp;
  background: #fff;
  padding: 40px 0 0 34px;
  border-right: 1px solid #e0e0e0;
  table {
    width: calc(100% - 44px);
    th {
      height: 50px;
    }
  }
  & .echo-status {
    display: flex;
    align-items: center;

    & button {
      max-width: 50%;
    }
    ${SubLabel}
  }
`;

export const SslSection = styled.section`
  grid-area: ssl;
  background: #fff;
  padding: 40px 0 0 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  ${SubLabel};
  & > label {
    margin: 0 0 5px 10px;
  }
  & > div {
    margin: 5px 0;
  }
`;

export const FieldCloseButton = styled.div`
  visibility: hidden;
  box-sizing: border-box;
  position: absolute;
  top: -1px;
  right: -1px;
  width: 30px;
  height: 30px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  &:before {
    content: '';
    ${CrossIcon};
    transform: rotate(45deg);
    --color: #999;
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
`;

export const StyledTxtSuccess = styled.p`
  margin: 0 0 0 auto;
  text-align: center;
  cursor: default;
  & span {
    padding-left: 30px;
    font-size: 16px;
    font-weight: bold;
    background: url(${icons.success}) no-repeat left center;
    background-size: 28px 28px;
    color: #00c1ca;
  }
`;

export const StyledTxtReady = styled.p`
  margin: 0 0 0 auto;
  text-align: center;
  cursor: default;
  & span {
    padding-left: 30px;
    font-size: 16px;
    font-weight: bold;
    background-size: 28px 28px;
    color: #919191;
  }
`;

export const StyledTxtError = styled.p`
  margin: 0 0 0 auto;
  text-align: center;
  cursor: default;
  & span {
    padding-left: 30px;
    font-size: 16px;
    font-weight: bold;
    background: url(${icons.error}) no-repeat left center;
    background-size: 28px 28px;
    color: #ff3939;
  }
`;

export const StyledCopyWrap = styled.div`
  position: absolute;
  top: 30px;
  right: 50px;
`;
